<template>
  <PostsList
    :resource="resource"
    :columns="headers"
    title="Склады вне Украины"
    :add-route="{ name: 'warehouses-post' }"
    store="warehousesPosts"
    path="warehouses"
  />
</template>

<script>
import PostsList from "../components/PostsList.vue";

export default {
  components: {
    PostsList,
  },
  data() {
    return {
      resource: "posts/warehouses",
      headers: [
        { text: "Ид",name: "id", width: "30", maxLength: 10, dataPath: "id" },
        { text: "Наименование", name: "text", width: "250", maxLength: 25, dataPath: "title" },
        { text: "Автор", type: "object", name: "author", width: "150", maxLength: 15, dataPath: "author" },
        {
          text: "Опубликовано",
          name: "isPublished",
          width: "80",
          maxLength: 10,
          valueFn(i) {
            return i.isPublished ? "Да" : "Нет";
          },
        },
        { text: "", sortable: false, type: "action", width: "130" },
      ],
    };
  },
};
</script>
